// extracted by mini-css-extract-plugin
export default {"album":"flickrPhotoSet_album__-InSM"};